/** @lint */

/**
 * @module orb/features/_drawerManager
 */
define('orb/features/_drawerManager', [
  'orb/features/masthead/_drawer',
], function (Drawer) {
  'use strict';

  var drawerElement = document.getElementById('orb-panels');
  var mastheadDrawer = new Drawer(drawerElement);
  var header = document.getElementById('orb-header'),
    NAV_HILITE = 'orb-nav-focus-on',
    ANIM_DURATION = 400,
    ACTIVE_PANEL_CLASS = 'orb-panel-active',
    ACTIVE_HEADER_CLASS = 'orb-nav-active',
    FIRST_VISIBLE_CLASS = 'orb-first-visible';

  /**
        Implement the masthead drawer and panel feature.
        @author Michael Mathews
        @author Robin Murphy
        @author Nikos Tsouknidas
        @author Philip Whitehall
     */
  function exports() {
    var templateText,
      closePanelTimer = null;

    function animateElementHeight(el, opts) {
      function easeOut(t, b, c, d) {
        t /= d;
        return -c * t * (t - 2) + b;
      }

      var startHeight = parseFloat(el.offsetHeight),
          targetHeight = opts.height,
          duration = opts.duration,
          style = el.style,
          frameInterval = 10,
          startTime = (new Date()).getTime(),
          tick;

      clearTimeout(el.orbAnimTimer); // Ensure only one anim per element

      return new Promise(function (resolve, reject) {
        if ( duration === 0 ) {
          style.height = targetHeight + 'px';
          resolve();
        } else {
          tick = function () {
            var elapsedTime = (new Date()).getTime() - startTime,
                newHeight = easeOut(elapsedTime, startHeight, targetHeight - startHeight, duration);

            if (elapsedTime > duration) {
              style.height = targetHeight + 'px';
              resolve();
              return;
            }

            style.height = newHeight + 'px';
            el.orbAnimTimer = setTimeout(tick, frameInterval);
          };

          el.orbAnimTimer = setTimeout(tick, 0);
        }
      });
    }

    /**
     * Given a panel object, perform the steps to animate that panel from a closed appearance to an open one.
     * @param {Drawer.Panel} panel - The panel object to be opened.
     */
    function animPanelOpen(panel) {
      if (!panel) {
        return;
      }

      header.classList.add(ACTIVE_HEADER_CLASS);
      panel.control.classList.add(NAV_HILITE);

      var panelToExpand = panel.content;
      panelToExpand.style.display = 'block';
      var panelToExpandHeight = panelToExpand.offsetHeight;

      var panelsContainer = mastheadDrawer.content;
      panelsContainer.style.height = '0px';
      panelsContainer.setAttribute('aria-expanded', 'true');
      panelsContainer.classList.add(ACTIVE_PANEL_CLASS);

      if (header.navMode === 'mouse') {
        animateElementHeight(panelsContainer, {
          height: panelToExpandHeight,
          duration: ANIM_DURATION
        }).then(function() {
          panelsContainer.style.display = 'inline';
        });
        panelToExpand.setAttribute('tabindex', '-1');
        panelToExpand.focus();
        return;
      }

      panelsContainer.style.display = 'inline';

      var focusTarget = panel.content.querySelector('.' + FIRST_VISIBLE_CLASS + ' a', panel.content)
          || panel.content.querySelector(".orb-first-target");
      if (focusTarget) {
        focusTarget.focus();
      }
    }

    /**
     * Given a panel object, perform the steps to animate that panel from a open appearance to a closed one.
     * @param {Drawer.Panel} panel - The panel object to be closed.
     */
    function animPanelClose(panel) {
      if (!panel) {
        return;
      }

      header.classList.remove(ACTIVE_HEADER_CLASS);
      panel.control.classList.remove(NAV_HILITE);

      var panelToClose = panel.content;
      var panelToCloseHeight = panelToClose.offsetHeight + 'px';

      var panelsContainer = mastheadDrawer.content;
      panelsContainer.style.display = 'block';
      panelsContainer.style.height = panelToCloseHeight;
      panelsContainer.classList.remove(ACTIVE_PANEL_CLASS);
      panelsContainer.setAttribute('aria-expanded', 'false');

      if (header.navMode === 'mouse') {
        animateElementHeight(panelsContainer, {
          height: 0,
          duration: ANIM_DURATION
        }).then(function() {
          panelToClose.style.display = 'none';
        });
        panel.content.setAttribute('tabindex', '-1');
        panel.content.focus();
        return;
      }

      panelsContainer.style.height = '0px';
      panelToClose.style.display = 'none';
    }

    /**
     * Given two panel objects, perform the steps to animate the swap of these panels.
     * @param {Drawer.Panel} currentPanel - The current panel object.
     * @param {Drawer.Panel} activatedPanel - The panel object that was just activated.
     */
    function animPanelSwap(currentPanel, activatedPanel) {
      currentPanel.control.classList.remove(NAV_HILITE);
      activatedPanel.control.classList.add(NAV_HILITE)

      var panelToReplace = currentPanel.content;
      var panelToReplaceHeight = panelToReplace.offsetHeight + 'px';

      var panelsContainer = mastheadDrawer.content;
      panelsContainer.style.height = panelToReplaceHeight;
      panelsContainer.style.display = 'block';
      panelToReplace.style.display = 'none';

      var newPanel = activatedPanel.content;
      newPanel.style.display = 'block';
      var newPanelHeight = newPanel.offsetHeight;

      if (header.navMode === 'mouse') {
        animateElementHeight(panelsContainer, {
          height: newPanelHeight,
          duration: ANIM_DURATION
        }).then(function() {
          panelsContainer.style.display = 'inline';
        });
        newPanel.setAttribute('tabindex', '-1');
        newPanel.focus();
        return;
      }

      panelsContainer.style.display = 'inline';

      linkToFocus = activatedPanel.content.querySelector(".orb-first-visible a")
      if (linkToFocus) {
        linkToFocus.focus();
      }
    }

    /**
            The masthead tracks whether the user is navigating by mouse or keyboard, and
            exposes that as a property named "navmode".
         */
    function addMastheadEvents() {
      // feature behaviours may vary depending on the user's current mode of navigation
      header.addEventListener('mousemove', function (e) {
        header.navMode = 'mouse';
      });
      header.addEventListener('mousedown', function (e) {
        header.navMode = 'mouse';
      });
      header.addEventListener('keydown', function (e) {
        header.navMode = 'keyboard';
      });
    }

    // when the DOM is ready, we can initialise the more panel and the drawer that holds it
    function readyHandler() {
      header.drawer = mastheadDrawer;

      var orbPanels = header.querySelector('#orb-panels');
      orbPanels.addEventListener('onActivate', function () {
        var panel = mastheadDrawer.getPanel(mastheadDrawer.panelName);
        animPanelOpen(panel);
      });
      orbPanels.addEventListener('onDeactivate', function () {
        var panel = mastheadDrawer.getPanel();
        animPanelClose(panel);
      });
      orbPanels.addEventListener('onSwapContents', function () {
        var currentPanel =
            mastheadDrawer.panels[mastheadDrawer.deactivatedPanelName],
          activatedPanel = mastheadDrawer.getPanel();

        animPanelSwap(currentPanel, activatedPanel);
      });

      addMastheadEvents();
    };

    function ready() {
      if (document.readyState != 'loading') {
        readyHandler();
      } else {
        document.addEventListener('DOMContentLoaded', readyHandler);
      }
    }
    ready();
  }

  /**
     Given a panel, add click handler to the panel's control which will tell
     the drawer to show that panel's content. Adds both mouse and keyboard
     navigation event handlers.
     @param {Drawer.Panel} panel - The panel to adent handlers to.
     */
  exports.addPanelEvents = function (panel) {
    var panelName = panel.name;
    // user pressed mouse, or return key, etc, on our panel link
    panel.control.addEventListener('click', function (e) {
      mastheadDrawer.showPanel(panelName);

      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }

      return false;
    });

    // if escape key pressed while any panel has focus
    header.addEventListener('keydown', function (e) {
      var charCode = typeof e.which === 'number' ? e.which : e.keyCode;
      // close the drawer if either the drawer, an interactive element on the drawer or the drawer opener has focus
      if (charCode === 27) {
        mastheadDrawer.hidePanel(panelName);
        var controlLink = panel.control.querySelector('a');
        if (controlLink) {
          controlLink.focus();
        }
      }
    });
  };

  exports.getMastheadDrawer = function () {
    return mastheadDrawer;
  };

  return exports;
});
